/**
 * Define product template (OS2.0)
 */

window.addEventListener('DOMContentLoaded', () => {
  const formPopup = document.getElementById('product-form-popup');

  // ポップアップ背景がクリックされた時
  addEventListener('click', outsideClose);
  function outsideClose(e) {
    if (e.target == formPopup) {
      formPopup.style.display = 'none';
    }
  };
});

// ポップアップ表示ボタンがクリックされた時
const formPopupOpen = ()=>{
  const formPopup = document.getElementById('product-form-popup');
  formPopup.style.display = 'block';

  calcAdditionalProductHeight();
  updDeliveryDatePicker();

  // 2023.6.21 Add : 数量1の場合、複数配送先を指定しないに設定して非表示に
  const inputQty = Number(document.getElementById('input-quantity').value);
  if(inputQty === 1){
    const mulit_delivery_address = document.querySelector("#gift--multi-delivery-address-umu"),
      mulit_delivery_address_umu_wrapper = document.querySelector('#gift-wrapper--multi-delivery-address-umu');

      mulit_delivery_address.value = "なし"
      mulit_delivery_address.dispatchEvent(new Event('change', {bubbles: true, composed: true}));
      mulit_delivery_address_umu_wrapper.setAttribute('hidden',true);
  }
}
// 閉じるボタンがクリックされた時
const formPopupClose = ()=>{
  const formPopup = document.getElementById('product-form-popup');
  formPopup.style.display = 'none';
}

/*
  -- Start: 個別にお届け先を指定 --
*/
// お届け先を指定セレクターの生成
const renderDiffAddressSelector = (_index,_diff_address_fields,_status) => {
  const selector_diff_address = `
    <div class="c-gift-field c-gift-field__diff-address-selector" id="gift-wrapper--diff-address-select--${_index}" data-nth_diff_address_selector="${_index}" ${_status === "hidden" ? "hidden" : ""}>
      <label class="c-gift-input__label" for="gift-wrapper--diff-address--${_index}">${_index}つ目のお届け先</label>
      <span class="c-gift__help">${_index}つ目の商品を1つ目とは異なるお届け先に指定する場合、<b>個別にお届け先を指定する</b>をご選択ください</span>
      <select ${_status === "hidden" ? "" : `name="${_index}つ目のお届け先"`} class="c-selector" data-type="select"
        value="1つ目と同じお届け先"
        onchange="selectDiffAddress(event)"
        data-nth_selector_item="${_index}">
        <option value="1つ目と同じお届け先" selected>1つ目と同じお届け先</option>
        <option value="個別にお届け先を指定する">個別にお届け先を指定する</option>
      </select>
    </div>
  
    <div class="c-gift-field" id="gift-wrapper--diff-address-field--${_index}" hidden="true">
      <fieldset class="c-radio__wrapper">
        <label class="c-gift-input__label " for="gift--diff-address-name--${_index}">お名前</label>
        <input type="text" id="gift--diff-address-name--${_index}" class="c-text" placeholder="お名前" data-type="text">
        <label class="c-gift-input__label " for="gift--diff-address-zip--${_index}">郵便番号</label>
        <input type="text" id="gift--diff-address-zip--${_index}" class="c-text" placeholder="郵便番号" data-type="text">
        <label class="c-gift-input__label " for="gift--diff-address-province--${_index}">都道府県</label>
        <select id="gift--diff-address-province--${_index}" class="c-selector" data-type="select">
          <option value="北海道">北海道</option>
          <option value="青森県">青森県</option>
          <option value="岩手県">岩手県</option>
          <option value="宮城県">宮城県</option>
          <option value="秋田県">秋田県</option>
          <option value="山形県">山形県</option>
          <option value="福島県">福島県</option>
          <option value="茨城県">茨城県</option>
          <option value="栃木県">栃木県</option>
          <option value="群馬県">群馬県</option>
          <option value="埼玉県">埼玉県</option>
          <option value="千葉県">千葉県</option>
          <option value="東京都">東京都</option>
          <option value="神奈川県">神奈川県</option>
          <option value="新潟県">新潟県</option>
          <option value="富山県">富山県</option>
          <option value="石川県">石川県</option>
          <option value="福井県">福井県</option>
          <option value="山梨県">山梨県</option>
          <option value="長野県">長野県</option>
          <option value="岐阜県">岐阜県</option>
          <option value="静岡県">静岡県</option>
          <option value="愛知県">愛知県</option>
          <option value="三重県">三重県</option>
          <option value="滋賀県">滋賀県</option>
          <option value="京都府">京都府</option>
          <option value="大阪府">大阪府</option>
          <option value="兵庫県">兵庫県</option>
          <option value="奈良県">奈良県</option>
          <option value="和歌山県">和歌山県</option>
          <option value="鳥取県">鳥取県</option>
          <option value="島根県">島根県</option>
          <option value="岡山県">岡山県</option>
          <option value="広島県">広島県</option>
          <option value="山口県">山口県</option>
          <option value="徳島県">徳島県</option>
          <option value="香川県">香川県</option>
          <option value="愛媛県">愛媛県</option>
          <option value="高知県">高知県</option>
          <option value="福岡県">福岡県</option>
          <option value="佐賀県">佐賀県</option>
          <option value="長崎県">長崎県</option>
          <option value="熊本県">熊本県</option>
          <option value="大分県">大分県</option>
          <option value="宮崎県">宮崎県</option>
          <option value="鹿児島県">鹿児島県</option>
          <option value="沖縄県">沖縄県</option>
        </select>
        <label class="c-gift-input__label " for="gift--diff-address-city--${_index}">市区町村</label>
        <input type="text" id="gift--diff-address-city--${_index}" class="c-text" placeholder="市区町村" data-type="text">
        <label class="c-gift-input__label " for="gift--diff-address-address1--${_index}">住所</label>
        <input type="text" id="gift--diff-address-address1--${_index}" class="c-text" placeholder="住所" data-type="text">
        <label class="c-gift-input__label " for="gift--diff-address-address2--${_index}">建物名</label>
        <input type="text" id="gift--diff-address-address2--${_index}" class="c-text" placeholder="建物名" data-type="text">
        <label class="c-gift-input__label " for="gift--diff-address-phone--${_index}">電話番号</label>
        <input type="tel" id="gift--diff-address-phone--${_index}" class="c-text" placeholder="電話番号" data-type="text">
      </fieldset>
    </div>
  `;
  _diff_address_fields.insertAdjacentHTML('beforeend', selector_diff_address);
}
// お届け先のセレクターを再表示
const visibleDiffAddressSelector = (_index) => {
  const target_selector = document.querySelector(`.c-gift-field__diff-address-selector[data-nth_diff_address_selector="${_index}"]`);

  // すでにレンダリング済みの場合、セレクターを表示
  target_selector.removeAttribute('hidden');
  target_selector.querySelector('select').setAttribute('name',`${_index}つ目のお届け先`);
  // 再表示セレクター = "個別にお届け先を指定する"の場合、フィールド表示
  if(target_selector.querySelector('select').value === "個別にお届け先を指定する"){
    visibleDiffAddressField(_index);
  }
}
// お届け先のセレクターを非表示
const hiddenDiffAddressSelector = (_index) => {
  document.querySelector(`[data-nth_diff_address_selector="${_index}"]`).setAttribute('hidden',true);
  document.querySelector(`[data-nth_diff_address_selector="${_index}"] select`).removeAttribute('name');

  // 非表示セレクター = "個別にお届け先を指定する" の場合、フィールドを非表示
  hiddenDiffAddressField(_index)
}

// お届け先のセレクター選択時
const selectDiffAddress = (e)=>{
  const selector_index = e.target.dataset.nth_selector_item;
  
  if(e.target.value === "1つ目と同じお届け先"){
    // 1つ目と同じお届け先
    hiddenDiffAddressField(selector_index)
  }else{
    // 個別にお届け先を指定する
    visibleDiffAddressField(selector_index)
  }
}

// お届け先のフィールド表示処理
const visibleDiffAddressField = (selector_index)=>{
  const nth_field_wrapper = document.querySelector(`#gift-wrapper--diff-address-field--${selector_index}`);
  nth_field_wrapper.removeAttribute('hidden');
  nth_field_wrapper.querySelectorAll('[data-type]').forEach(elem => {
    if(elem.id === `gift--diff-address-zip--${selector_index}`){
      elem.setAttribute('name',`properties[郵便番号(${selector_index}つ目)]`);
    }else if(elem.id === `gift--diff-address-province--${selector_index}`){
      elem.setAttribute('name',`properties[都道府県(${selector_index}つ目)]`);
    }else if(elem.id === `gift--diff-address-city--${selector_index}`){
      elem.setAttribute('name',`properties[市区町村(${selector_index}つ目)]`);
    }else if(elem.id === `gift--diff-address-address1--${selector_index}`){
      elem.setAttribute('name',`properties[住所(${selector_index}つ目)]`);
    }else if(elem.id === `gift--diff-address-address2--${selector_index}`){
      elem.setAttribute('name',`properties[建物名(${selector_index}つ目)]`);
    }else if(elem.id === `gift--diff-address-name--${selector_index}`){
      elem.setAttribute('name',`properties[配送先 お名前(${selector_index}つ目)]`);
    }else if(elem.id === `gift--diff-address-phone--${selector_index}`){
      elem.setAttribute('name',`properties[電話番号(${selector_index}つ目)]`);
    }
  })
}
// お届け先のフィールド非表示処理
const hiddenDiffAddressField = (selector_index) => {
  const nth_field_wrapper = document.querySelector(`#gift-wrapper--diff-address-field--${selector_index}`);
  nth_field_wrapper.setAttribute('hidden',true);
  nth_field_wrapper.querySelectorAll('[data-type]').forEach(elem => {
    elem.removeAttribute('name');
  })
}
/*
  -- End: 個別にお届け先を指定 --
*/

// 数量変更
// ・引数
//  _target_id:数量変更対象のinput要素id
//  _btn_type:[minus/plus/input]
const changeQty = (_target_id,_btn_type)=>{
  const input_elem = document.getElementById(_target_id);
  let upd_value = Number(input_elem.value),
    error_flg = false;

  // 数量変更
  switch (_btn_type) {
    case 'minus':
      if(upd_value <= 1){
        alert("数量は1以上をご指定ください。");
        error_flg = true;
      }else{
        upd_value -= 1;
      }
      break;
    case 'plus':
      upd_value += 1;
      break;
  }

  // バリデーション
  if(/^-?\d+$/.test(upd_value) === false){
    alert("数量は整数をご指定ください。");
    error_flg = true;
  }else if(upd_value < 1){
    alert("数量は1以上をご指定ください。");
    error_flg = true;
  }

  // お届け先の生成・削除
  // 2023.6.21 Add : 数量1の場合、複数配送先を指定しないに設定して非表示に
  if(error_flg === false){
    const disp_diff_address_count = document.querySelectorAll('.c-gift-field__diff-address-selector:not([hidden])').length + 2,
      diff_address_fields = document.querySelector('#diff-address-fields'),
      mulit_delivery_address = document.querySelector("#gift--multi-delivery-address-umu"),
      mulit_delivery_address_umu_wrapper = document.querySelector('#gift-wrapper--multi-delivery-address-umu');

    if(upd_value === 1){
      // 数量1の場合
      mulit_delivery_address.value = "なし"
      mulit_delivery_address.dispatchEvent(new Event('change', {bubbles: true, composed: true}));
      mulit_delivery_address_umu_wrapper.setAttribute('hidden',true);
    }else{
      // 数量2以上の場合
      mulit_delivery_address_umu_wrapper.removeAttribute('hidden');
    }

    switch(mulit_delivery_address.value){
      case 'あり':
        // お届け先指定=あり
        if(upd_value >= disp_diff_address_count){
          // 数量よりすでに生成したセレクターが少ない場合、不足分だけセレクターを生成
          for (let index = disp_diff_address_count; index <= upd_value; index++) {
            const target_selector = document.querySelector(`.c-gift-field__diff-address-selector[data-nth_diff_address_selector="${index}"]`);
            if(target_selector){
              visibleDiffAddressSelector(index)
            }else{
              // 未レンダリング済みの場合、セレクターをレンダリング
              renderDiffAddressSelector(index,diff_address_fields,"visible");
            }
          }
        }else if(upd_value < disp_diff_address_count){
          // 数量がすでに生成したセレクターより少ない場合、過剰分だけセレクターを非表示
          for (let index = (disp_diff_address_count - 1); index > upd_value; index--) {
            hiddenDiffAddressSelector(index)
          }
        }
        break;
      case 'なし':
        // お届け先指定=なし
        if(upd_value >= disp_diff_address_count){
          // 数量よりすでに生成したセレクターが少ない場合、不足分だけセレクターを生成
          for (let index = disp_diff_address_count; index <= upd_value; index++) {
            const target_selector = document.querySelector(`.c-gift-field__diff-address-selector[data-nth_diff_address_selector="${index}"]`);
            if(target_selector){
              // なしの場合、生成済みに対しては何もしない
            }else{
              // 未レンダリング済みの場合、セレクターをレンダリング
              renderDiffAddressSelector(index,diff_address_fields,"hidden");
            }
          }
        }else if(upd_value < disp_diff_address_count ){
          // 数量がすでに生成したセレクターより少ない場合、過剰分だけセレクターを非表示
          for (let index = (disp_diff_address_count - 1); index > upd_value; index--) {
            hiddenDiffAddressSelector(index)
          }
        }
        break;
    }
  }

  input_elem.value = upd_value;
}

const clickedThumb = (_index)=>{
  document.querySelector(".product__thumbnail.is-selected").classList.remove("is-selected");
  document.querySelector(`.product__thumbnail[data-index="${_index}"]`).classList.add("is-selected");
}

// 2023.2.5 Add start : Calc additional product title height on GiftShip form
const calcAdditionalProductHeight = ()=>{
  const intervalId = setInterval(()=>{
    if(document.querySelectorAll('.gs__product-option[data-child-name="追加商品"] div[data-child-attribute="label"]').length > 0){
      const elem_height_array = [...document.querySelectorAll('.gs__product-option[data-child-name="追加商品"] div[data-child-attribute="label"]')].map(elem => elem.clientHeight);
      const elem_max_height = Math.max(elem_height_array[0]);
      document.querySelectorAll('.gs__product-option[data-child-name="追加商品"] ul li').forEach(elem => {
        elem.style.marginBottom = elem_max_height;
      })

      //ドキュメントが読み込まれば場合の処理
      clearInterval(intervalId);
    }
  },100);
}
// 2023.2.5 Add end : Calc additional product title height on GiftShip form

// 2023.3.9 Add start : 配送日時 表示名書き換え
const updDeliveryDatePicker = ()=>{
  const intervalId = setInterval(()=>{
    if(document.querySelector('.gs__product-option')){
      const delivery_picker = document.querySelector('.gs__product-option[data-child-name="配達時間帯"] select');
      if(delivery_picker){
        delivery_picker.querySelectorAll('option').forEach(option_elem => {
          switch(option_elem.value) {
            case '0812':
              option_elem.textContent = "8:00-12:00"
              break;
            case '1214':
              option_elem.textContent = "12:00-14:00"
              break;
            case '1416':
              option_elem.textContent = "14:00-16:00"
              break;
            case '1618':
              option_elem.textContent = "16:00-18:00"
              break;
            case '1820':
              option_elem.textContent = "18:00-20:00"
              break;
            case '2021':
              option_elem.textContent = "20:00-21:00"
              break;
            case '':
              option_elem.textContent = "指定なし"
              break;
          }
        })
      }

      //ドキュメントが読み込まれば場合の処理
      clearInterval(intervalId);
    }
  },100);
}
// 2023.3.9 Add end : 配送日時 表示名書き換え